import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useGenieBrandsOptions = () => {
  const brandOptions = useSelector((state) => state.genie.brandOptions ?? {});

  return useMemo(
    () =>
      Object.entries(brandOptions).map(([key, value]) => ({
        label: value,
        value: key,
      })),
    [brandOptions],
  );
};

export default useGenieBrandsOptions;
